import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { Outlet, useRoutes } from 'react-router-dom';
import JourneyManagement from '@components/application/JourneyManagement';
import CreateJourney from '@components/application/CreateJourney';
import ModalProposalConfirm from '@components/application/ModalProposalConfirm';
import ModalProposalReject from '@components/application/ModalProposalReject';

function RouterLocal({ isMobile }: { isMobile: boolean }) {
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <JourneyManagement isMobile={isMobile} />,
      children: [
        {
          path: 'avaliar-motorista',
          element: <Outlet />,
          children: [
            {
              path: ':journeyId',
              element: <Outlet />,
            },
          ],
        },
        {
          path: 'cadastrar',
          element: <CreateJourney isMobile={isMobile} />,
        },
        {
          path: 'monitorar/:monitoringJourneyId',
          element: <Outlet />,
        },
        {
          path: 'pre-viagem/:idProposal/aceite',
          element: <ModalProposalConfirm />,
        },
        {
          path: 'pre-viagem/:idProposal/recusa',
          element: <ModalProposalReject />,
        },
        {
          path: '*',
          element: <Outlet />,
        },
      ],
    },
  ];

  return useRoutes(routes);
}

export default RouterLocal;
